;(function (global, factory) {
    typeof define === 'function' && define.amd ? define('MM/Utils/notifier',["toastify"], factory)
    : typeof exports === 'object' && typeof module !== typeof void 0 ? module.exports = factory(require("toastify"))
    : console && console.error('Notifier does not support non-amd script loading.');
}(this /* window */, function(toastify) {
    function Notifier() {
        Object.defineProperty(this, 'defaultDuration', {writable: !1, enumerable: !0, configurable: !0, value: 10000 /* 10 sec */})
    }

    Notifier.prototype.pushCustomAsync = function(cssClass, msg, duration) {
        return this._pushAsync(cssClass, msg, duration);
    }

    Notifier.prototype.pushSuccessAsync = function(msg, duration) {
        return this._pushAsync('success', msg, duration);
    }

    Notifier.prototype.pushErrorAsync = function(msg, duration) {
        return this._pushAsync('error', msg, duration);
    }

    Notifier.prototype._pushAsync = function(cssClass, msg, duration) {
        if(msg === null || msg === void 0) Promise.reject(); 

        var toastOpt = {
            className: cssClass,
            gravity: 'bottom',
            position: 'right',
            stopOnFocus: !0,
            close: !0, 
            duration: duration || this.defaultDuration,
            role: 'alert'
        };
        if(msg instanceof HTMLElement || msg instanceof DocumentFragment) {
            // if msg message is a node element, then we should pass it into a diff parameter, so toastify whill inject it into the notification
            toastOpt['node'] = msg;
            // if message has any CTA. we have to make the toast message inifinity
            // requirement came from accessibility requirements
            if(msg.querySelector('a,button,form') != null) {
                toastOpt['duration'] = 0;
                toastOpt['role'] = 'alertdialog';
            }
        } else {
            // default message show
            toastOpt['text'] = msg;
        }

        return new Promise(function(resolve, reject){
            try {
                // setup resolve function, so the promist can be completed.
                toastOpt.onShown = resolve;

                // return instance of the toast
                new toastify(toastOpt).showToast();
            } catch (err){
                reject(err);
            }
        })
    }

    return Notifier;
}));
